import { render, staticRenderFns } from "./fixedAssetsCost.vue?vue&type=template&id=5f5b395c&scoped=true&"
import script from "./fixedAssetsCost.vue?vue&type=script&lang=js&"
export * from "./fixedAssetsCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b395c",
  null
  
)

export default component.exports